"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasskeyEnrollmentPrompt = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usePasskey_1 = require("./usePasskey");
const DISMISSED_KEY = 'moment-passkey-prompt-dismissed';
/**
 * Shown once per session after a user's first password-based login.
 * Renders only when the browser supports WebAuthn and the user has
 * no existing passkeys registered.
 */
const PasskeyEnrollmentPrompt = ({ accessToken, cognitoDomain, onDismiss, }) => {
    const { isPasskeySupported, isLoading, error, passkeys, registerPasskey, listPasskeys } = (0, usePasskey_1.usePasskey)();
    const [checked, setChecked] = (0, react_1.useState)(false);
    const [registered, setRegistered] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!isPasskeySupported) {
            setChecked(true);
            return;
        }
        if (sessionStorage.getItem(DISMISSED_KEY)) {
            onDismiss();
            return;
        }
        listPasskeys(accessToken, cognitoDomain).finally(() => setChecked(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismiss = () => {
        sessionStorage.setItem(DISMISSED_KEY, '1');
        onDismiss();
    };
    const handleRegister = async () => {
        await registerPasskey(accessToken, cognitoDomain);
        if (!error) {
            setRegistered(true);
            setTimeout(handleDismiss, 1500);
        }
    };
    if (!checked || !isPasskeySupported || passkeys.length > 0)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { role: "dialog", "aria-modal": "true", "aria-label": "Register a passkey", style: {
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 9999,
            background: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: 12,
            boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
            padding: '20px 24px',
            maxWidth: 340,
            fontFamily: 'inherit',
        }, children: registered ? ((0, jsx_runtime_1.jsx)("p", { style: { margin: 0, color: '#2e7d32', fontWeight: 600 }, children: "Passkey registered!" })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { style: { margin: '0 0 12px', fontWeight: 600, fontSize: 15 }, children: "Sign in faster with a passkey" }), (0, jsx_runtime_1.jsx)("p", { style: { margin: '0 0 16px', fontSize: 13, color: '#555' }, children: "Use Face ID, Touch ID, or your device PIN instead of your password next time." }), error && ((0, jsx_runtime_1.jsx)("p", { style: { margin: '0 0 12px', fontSize: 12, color: '#c62828' }, children: error })), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: 8 }, children: [(0, jsx_runtime_1.jsx)("button", { onClick: handleRegister, disabled: isLoading, style: {
                                flex: 1,
                                padding: '8px 0',
                                borderRadius: 8,
                                border: 'none',
                                background: '#1976d2',
                                color: '#fff',
                                fontWeight: 600,
                                fontSize: 13,
                                cursor: isLoading ? 'wait' : 'pointer',
                            }, children: isLoading ? 'Registering…' : 'Set up passkey' }), (0, jsx_runtime_1.jsx)("button", { onClick: handleDismiss, style: {
                                padding: '8px 12px',
                                borderRadius: 8,
                                border: '1px solid #e0e0e0',
                                background: 'transparent',
                                fontSize: 13,
                                cursor: 'pointer',
                            }, children: "Not now" })] })] })) }));
};
exports.PasskeyEnrollmentPrompt = PasskeyEnrollmentPrompt;
